/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
} from './APIMeta';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
} from './APIResponseError';

/**
 * 
 * @export
 * @interface PostPersonsAnonymous201Response
 */
export interface PostPersonsAnonymous201Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof PostPersonsAnonymous201Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof PostPersonsAnonymous201Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {string}
     * @memberof PostPersonsAnonymous201Response
     */
    result: string;
}

/**
 * Check if a given object implements the PostPersonsAnonymous201Response interface.
 */
export function instanceOfPostPersonsAnonymous201Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function PostPersonsAnonymous201ResponseFromJSON(json: any): PostPersonsAnonymous201Response {
    return PostPersonsAnonymous201ResponseFromJSONTyped(json, false);
}

export function PostPersonsAnonymous201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPersonsAnonymous201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': !exists(json, 'meta') ? undefined : APIMetaFromJSON(json['meta']),
        'errors': !exists(json, 'errors') ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': json['result'],
    };
}

export function PostPersonsAnonymous201ResponseToJSON(value?: PostPersonsAnonymous201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': APIMetaToJSON(value.meta),
        'errors': value.errors === undefined ? undefined : ((value.errors as Array<any>).map(APIResponseErrorToJSON)),
        'result': value.result,
    };
}

